import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Clock, Instagram, Facebook } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mindful-halotherapy/artifacts/6y9td2wh_logo%20marron.png";

export const Footer = () => {
  return (
    <footer className="bg-halo-charcoal text-halo-cream" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="space-y-6">
            <img 
              src={LOGO_URL} 
              alt="HALO Cuevas de Sal" 
              className="h-16 w-auto brightness-0 invert opacity-90"
            />
            <p className="text-halo-taupe text-sm leading-relaxed">
              Un espacio de bienestar donde la haloterapia se integra con prácticas 
              conscientes para el cuidado respiratorio y la regulación del sistema nervioso.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/halo_cuevas/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-halo-cream/10 hover:bg-halo-brown transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-halo-cream/10 hover:bg-halo-brown transition-colors"
                aria-label="Facebook"
                data-testid="footer-facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-6">Navegación</h4>
            <ul className="space-y-3">
              {[
                { name: 'Haloterapia', path: '/haloterapia' },
                { name: 'Servicios', path: '/servicios' },
                { name: 'Beneficios', path: '/beneficios' },
                { name: 'Familias', path: '/familias' },
                { name: 'Nuestra Filosofía', path: '/filosofia' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-halo-taupe hover:text-halo-cream transition-colors text-sm"
                    data-testid={`footer-link-${link.path.replace('/', '')}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg mb-6">Servicios</h4>
            <ul className="space-y-3">
              {[
                'Sesiones Libres',
                'Yoga en Cueva de Sal',
                'Meditación Guiada',
                'Sesiones de Silencio',
                'Sesiones en Familia',
                'Masaje en Gabinete',
              ].map((service) => (
                <li key={service}>
                  <Link 
                    to="/servicios"
                    className="text-halo-taupe hover:text-halo-cream transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg mb-6">Contacto</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:678901086" 
                  className="flex items-start gap-3 text-halo-taupe hover:text-halo-cream transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} className="mt-0.5 flex-shrink-0" />
                  <span className="text-sm">678 901 086</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:info@halocuevas.com" 
                  className="flex items-start gap-3 text-halo-taupe hover:text-halo-cream transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} className="mt-0.5 flex-shrink-0" />
                  <span className="text-sm">info@halocuevas.com</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-halo-taupe">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  C/ Miquel Caplloch 6, Local 12<br />
                  Palma de Mallorca
                </span>
              </li>
              <li className="flex items-start gap-3 text-halo-taupe">
                <Clock size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm">
                  Lun - Vie: 10:00 - 20:00<br />
                  Sáb: 10:00 - 14:00
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-halo-cream/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-halo-taupe text-sm">
              © {new Date().getFullYear()} HALO Cuevas de Sal. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacidad" className="text-halo-taupe hover:text-halo-cream transition-colors">
                Política de Privacidad
              </Link>
              <Link to="/aviso-legal" className="text-halo-taupe hover:text-halo-cream transition-colors">
                Aviso Legal
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
